export class TextTags {
    parent;
    constructor(parent) {
        this.parent = parent;
    }
    get text() {
        return this.parent;
    }
    get autoTags() {
        return [];
    }
}
